import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { HelpCircle } from 'lucide-react';

const FAQ = () => {
  const faqs = [
    {
      question: "Apakah saya perlu pengalaman trading untuk menggunakan Sahara AI?",
      answer: "Tidak sama sekali! Itulah keindahan copy trading. AI kami memfilter dan memonitor strategi profesional, jadi kamu bisa mengakses peluang trading tanpa pengetahuan trading yang mendalam. Cukup pilih strategi dan biarkan berjalan otomatis."
    },
    {
      question: "Berapa modal minimum untuk memulai?",
      answer: "Kamu bisa mulai dengan modal serendah Rp 1,5 juta (sekitar $100). Namun, kami merekomendasikan mulai dengan Rp 7-15 juta untuk risk management yang lebih baik dan lebih banyak pilihan strategi. Dana kamu tetap di akun broker kamu sendiri - kami tidak pernah memegang uang kamu."
    },
    {
      question: "Apakah uang saya aman? Bisakah saya menarik kapan saja?",
      answer: "Ya, tentu saja. Dana kamu tetap berada di akun broker teregulasi milik kamu sendiri. Kamu memiliki kontrol penuh dan bisa menarik kapan saja tanpa batasan. Kami hanya menyalin trade - kami tidak pernah menyentuh uang kamu."
    },
    {
      question: "Apa perbedaan Sahara AI dengan platform copy trading lainnya?",
      answer: "Berbeda dengan platform lain yang membiarkan siapa saja menjadi 'master trader', Sahara AI menggunakan AI canggih untuk memfilter ribuan strategi. Hanya performer terbukti dengan profit konsisten dan risiko rendah yang lolos. Kamu mengcopy yang terbaik, bukan berjudi pada trader yang belum terverifikasi."
    },
    {
      question: "Bagaimana cara kerja AI-nya?",
      answer: "AI kami menganalisis performa historis, win rate, level drawdown, frekuensi trading, dan pola risiko dari ribuan strategi. Sistem ini terus memonitor performa secara real-time dan hanya merekomendasikan strategi yang memenuhi kriteria ketat kami untuk konsistensi dan keamanan."
    },
    {
      question: "Berapa biayanya?",
      answer: "Harga transparan: Kamu hanya membayar profit-sharing fee (20-30% tergantung strategi) ketika kamu mendapat profit. Tidak ada biaya bulanan, tidak ada biaya tersembunyi. Jika strategi tidak profit, kamu tidak membayar apa-apa."
    },
    {
      question: "Bisakah saya kehilangan uang?",
      answer: "Seperti semua bentuk trading dan investasi, ada risiko yang terlibat. Namun, strategi yang difilter AI kami memiliki risk management ketat (Risk Level 1) untuk meminimalkan kerugian. Performa masa lalu tidak menjamin hasil di masa depan. Kami selalu merekomendasikan hanya berinvestasi dengan dana yang mampu kamu tanggung jika terjadi kerugian."
    },
    {
      question: "Berapa lama untuk melihat hasil?",
      answer: "Waktu untuk melihat hasil bervariasi tergantung kondisi market dan strategi yang dipilih. Copy trading adalah strategi jangka panjang. Performer terbaik kami menunjukkan hasil optimal dalam periode 3-12 bulan ketika compound growth mulai berjalan. Ingat: hasil trading tidak bisa dijamin dan bervariasi untuk setiap pengguna."
    }
  ];

  return (
    <div className="faq-section-wrapper">
      <div className="faq-header">
        <HelpCircle className="faq-icon" />
        <h2 className="faq-title">Pertanyaan yang Sering Ditanyakan</h2>
        <p className="faq-subtitle">Semua yang perlu kamu ketahui sebelum memulai</p>
      </div>

      <Accordion type="single" collapsible className="faq-accordion">
        {faqs.map((faq, index) => (
          <AccordionItem key={index} value={`item-${index}`} className="faq-item">
            <AccordionTrigger className="faq-question">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="faq-answer">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="faq-cta">
        <p>Masih ada pertanyaan? <a href="https://t.me/saharacopytrade" target="_blank" rel="noopener noreferrer" className="faq-link">Gabung Telegram kami</a> untuk bantuan langsung</p>
      </div>
    </div>
  );
};

export default FAQ;
